// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>4</span>&nbsp;&nbsp;How shall we sing the Lord&#146;s song&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;in a strange land?<br> </p> </div></div>";
// Exports
module.exports = code;